var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_identificacion,
                      expression: "form.tipo_identificacion"
                    }
                  ],
                  attrs: {
                    name: "tipo_identificacion",
                    id: "tipo_identificacion",
                    disabled: this.clienteId != ""
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "tipo_identificacion",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Seleccione...")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "C" } }, [_vm._v("Cédula")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "R" } }, [_vm._v("Ruc")])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_identificacion" } }, [
                _vm._v("Tipo de identificación")
              ]),
              _vm._v(" "),
              _vm.errores.tipo_identificacion
                ? _c(
                    "span",
                    {
                      staticClass: "helper-text text-danger",
                      attrs: { slot: "helper" },
                      slot: "helper"
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.errores.tipo_identificacion[0]))
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    readonly: this.clienteId != "",
                    placeholder: "Escriba un número de identificación...",
                    id: "numero_identificacion"
                  },
                  model: {
                    value: _vm.form.numero_identificacion,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "numero_identificacion", $$v)
                    },
                    expression: "form.numero_identificacion"
                  }
                },
                [
                  _vm._v("\n          # Identificacion\n          "),
                  _vm.errores.numero_identificacion
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.numero_identificacion[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: { placeholder: "Escriba un nombre...", id: "nombres" },
                  model: {
                    value: _vm.form.nombres,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "nombres", $$v)
                    },
                    expression: "form.nombres"
                  }
                },
                [
                  _vm._v("\n          Nombre\n          "),
                  _vm.errores.nombres
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [_c("strong", [_vm._v(_vm._s(_vm.errores.nombres[0]))])]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba un segundo nombre...",
                    id: "segundo_nombre"
                  },
                  model: {
                    value: _vm.form.segundo_nombre,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "segundo_nombre", $$v)
                    },
                    expression: "form.segundo_nombre"
                  }
                },
                [
                  _vm._v("\n          Segundo nombre\n          "),
                  _vm.errores.segundo_nombre
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.segundo_nombre[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba un apellido...",
                    id: "apellidos"
                  },
                  model: {
                    value: _vm.form.apellidos,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "apellidos", $$v)
                    },
                    expression: "form.apellidos"
                  }
                },
                [
                  _vm._v("\n          Apellido\n          "),
                  _vm.errores.apellidos
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.apellidos[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba un apellido...",
                    id: "segundo_apellido"
                  },
                  model: {
                    value: _vm.form.segundo_apellido,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "segundo_apellido", $$v)
                    },
                    expression: "form.segundo_apellido"
                  }
                },
                [
                  _vm._v("\n          Segundo apellido\n          "),
                  _vm.errores.segundo_apellido
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.segundo_apellido[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba una dirección...",
                    id: "direccion"
                  },
                  model: {
                    value: _vm.form.direccion,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "direccion", $$v)
                    },
                    expression: "form.direccion"
                  }
                },
                [
                  _vm._v("\n          Dirección\n          "),
                  _vm.errores.direccion
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.direccion[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba uno o varios teléfonos...",
                    id: "telefonos"
                  },
                  model: {
                    value: _vm.form.telefonos,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "telefonos", $$v)
                    },
                    expression: "form.telefonos"
                  }
                },
                [
                  _vm._v("\n          Teléfonos\n          "),
                  _vm.errores.telefonos
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.telefonos[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "Escriba uno o varios celulares...",
                    id: "celulares"
                  },
                  model: {
                    value: _vm.form.celulares,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "celulares", $$v)
                    },
                    expression: "form.celulares"
                  }
                },
                [
                  _vm._v("\n          Celular\n          "),
                  _vm.errores.celulares
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.celulares[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c(
                "input-field",
                {
                  attrs: {
                    placeholder: "$ #,###.##",
                    id: "cupo_maximo",
                    vMoney: "",
                    format: _vm.money
                  },
                  model: {
                    value: _vm.form.cupo_maximo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "cupo_maximo", $$v)
                    },
                    expression: "form.cupo_maximo"
                  }
                },
                [
                  _vm._v("\n          Cupo máximo\n          "),
                  _vm.errores.cupo_maximo
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.cupo_maximo[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "form-field select" }, [
            _c("div", { staticClass: "select-field" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoEstado,
                      expression: "form.tipoEstado"
                    }
                  ],
                  attrs: { name: "tipo_estado", id: "tipo_estado" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.form,
                        "tipoEstado",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "A" } }, [_vm._v("ACTIVO")]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "I" } }, [
                    _vm._v("INCOBRABLE")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("label", { attrs: { for: "tipo_estado" } }, [
                _vm._v("Estado cobro:")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-6" }, [
          _c("div", { staticClass: "form-field" }, [
            _c("p", [
              _c("strong", [_vm._v("Clave: ")]),
              _vm._v(" " + _vm._s(_vm.clave))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.puedeVerClaveAccesoWeb,
                expression: "puedeVerClaveAccesoWeb"
              }
            ],
            staticClass: "col-xs-12 col-md-6"
          },
          [
            _c("div", { staticClass: "form-field" }, [
              _c("p", [
                _c("strong", [_vm._v("Clave acceso web: ")]),
                _vm._v(" " + _vm._s(_vm.claveAccesoWeb))
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _vm.clienteId != ""
              ? _c("fotos-clientes", {
                  attrs: { fotos: _vm.fotos, clienteId: _vm.clienteId },
                  on: { fotosGuardadas: _vm.fotosGuardadas }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _vm.clienteId != ""
          ? _c(
              "button",
              { staticClass: "btn-secondary", on: { click: _vm.auditoria } },
              [
                _c("i", { staticClass: "fa fa-list" }),
                _c("span", [_vm._v("Auditoría")])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-success", on: { click: _vm.guardar } },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _c("span", [_vm._v("Guardar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cancelar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "clienteAuditoria",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "50%",
            clickToClose: ""
          }
        },
        [_c("auditoria-cliente", { attrs: { clienteId: _vm.clienteId } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Cliente")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e195326e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e195326e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/Cliente.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e195326e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/Cliente.vue
// module chunks = 0